<!-- =========================================================================================
  File Name: Parameters.vue
  Description: Parameters Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card class="mb-2">

      <div slot="no-body" class="tabs-container pl-6 py-5">
        <div class="w-full vx-row mb-2">
          <div class="vx-col w-2/12">
            <div class="flex items-center justify-center h-12 rounded bg-success">
              <div class="text-3xl text-white text-bold">Parámetros</div>
            </div>
          </div>
          <div class="flex vx-col w-10/12 items-center justify-end h-full">
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-primary text-white cursor-pointer" @click="save">
              <vs-icon icon-pack="feather" icon="icon-file-text" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Guardar</div>
            </div>
            <div class="flex items-center justify-center w-48 h-12 rounded-sm bg-danger text-white cursor-pointer" @click="reset_data">
              <vs-icon icon-pack="feather" icon="icon-corner-up-left" size="1.3rem" class="mr-2"/>
              <div class="mt-1">Cancelar</div>
            </div>
          </div>
        </div>
        <div class="w-full vx-row mb-4">
          <vs-divider position="left">Generales</vs-divider>
          <div class="vx-col w-full">
            <ejs-checkbox label='Tienda en mantenimiento' v-model="general.maintenance" :checked="general.maintenance"></ejs-checkbox>
          </div>
        </div>
        <div class="w-full vx-row mb-4">
          <vs-divider position="left">Página de inicio</vs-divider>
          <div class="vx-col w-full">
            <ejs-textbox floatLabelType="Auto" placeholder="Línea 1 de mensaje de despacho" v-model="home.deliveryLine1" :readonly="true"/>
          </div>
          <div class="vx-col w-full">
            <ejs-textbox floatLabelType="Auto" placeholder="Línea 2 de mensaje de despacho" v-model="home.deliveryLine2" :readonly="true"/>
          </div>
        </div>
        <div class="w-full vx-row mb-4 items-center">
          <vs-divider position="left">Órdenes</vs-divider>
          <div class="vx-col w-1/5">
            <ejs-numerictextbox floatLabelType="Auto" placeholder="Valor mínimo para colocar orden" format="N2" textAlign='Right' v-model="orders.orderMinimum"/>
          </div>
          <div class="vx-col w-1/5">
            <ejs-numerictextbox floatLabelType="Auto" placeholder="Último número de orden" format="N0" textAlign='Right' v-model="orders.orderNumber"/>
          </div>
          <div class="vx-col w-1/5">
            <ejs-checkbox label='Validar ubicación de dirección' v-model="orders.validateLocation" :checked="orders.validateLocation"></ejs-checkbox>
          </div>
        </div>
        <div class="w-full vx-row mb-4 items-center">
          <vs-divider position="left">Productos de temporada</vs-divider>
          <div class="vx-col w-full">
            <ejs-textbox floatLabelType="Auto" placeholder="Título de la sección" v-model="seasonal.title"/>
          </div>
          <div class="vx-col w-full">
            <ejs-multiselect
              ref="products"
              floatLabelType="Auto"
              placeholder="Productos incluídos"
              :dataSource="products"
              mode="Box"
              :fields="{text: 'searchField', value: 'id'}"
              v-model="seasonal.productsList"
              allowFiltering=true
              :filtering='productFiltering'
            />
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
  import Vue from "vue";
  import {Query} from "@syncfusion/ej2-data";
  import {TextBoxPlugin} from '@syncfusion/ej2-vue-inputs';
  import {NumericTextBoxPlugin} from "@syncfusion/ej2-vue-inputs";
  import {CheckBoxPlugin} from "@syncfusion/ej2-vue-buttons";
  import {MultiSelectPlugin} from "@syncfusion/ej2-vue-dropdowns";
  import {db} from '@/firebaseConfig';

  Vue.use(TextBoxPlugin);
  Vue.use(NumericTextBoxPlugin);
  Vue.use(CheckBoxPlugin);
  Vue.use(MultiSelectPlugin);

  export default {
    data() {
      return {
        general: {
          maintenance: false
        },
        home: {
          deliveryLine1: '',
          deliveryLine2: ''
        },
        orders: {
          creditCardType: 1,
          orderMinimum: 0,
          orderNumber: 0,
          showPreferedDeliveryTime: false,
          validateLocation: false
        },
        seasonal: {
          title: '',
          products: '',
          productsList: []
        },
        seasonalProductsList: null
      }
    },
    computed: {
      generalParams() {
        return this.$store.getters['getParameter']('general');
      },
      homeParams() {
        return this.$store.getters['getParameter']('home');
      },
      ordersParams() {
        return this.$store.getters['getParameter']('orders');
      },
      seasonalParams() {
        return this.$store.getters['getParameter']('seasonal');
      },
      products() {
        return this.$store.getters.productsList;
      }
    },
    methods: {
      productFiltering: function (e) {
        const searchData = JSON.parse(JSON.stringify(this.products));
        if (e.text == '') {
          e.updateData(searchData);
        } else {
          let query = new Query().select(['searchField', 'id']);
          query = (e.text !== '') ? query.where('searchField', 'contains', e.text, true, true) : query;
          e.updateData(searchData, query);
        }
      },
      reset_data() {
        this.general = {...this.generalParams};
        this.home = {...this.homeParams};
        this.orders = {...this.ordersParams};
        this.seasonal = {...this.seasonalParams};
        if (this.seasonal.products == '') {
          this.seasonal.productsList = [];
        } else {
          this.seasonal.productsList = this.seasonal.products.split(',');
        }
        this.seasonalProductsList = [...this.seasonal.productsList];
      },
      save() {
        this.$vs.loading({
          text: 'Guardando parámetros',
          type: 'point'
        });

        // Se agrupan todos los cambios en un único batch para hacer una sola
        // escritura atómica a Firestore en lugar de hasta 7 escrituras
        // independientes, reduciendo la cantidad de operaciones encoladas y el
        // riesgo de agotar el límite de escrituras pendientes del cliente
        // (resource-exhausted).
        const batch = db.batch();
        let hasChanges = false;

        const generalRef = db.collection('parameters').doc('general');
        const homeRef = db.collection('parameters').doc('home');
        const ordersRef = db.collection('parameters').doc('orders');
        const seasonalRef = db.collection('parameters').doc('seasonal');

        if (this.general.maintenance != this.generalParams.maintenance) {
          batch.update(generalRef, {maintenance: this.general.maintenance});
          hasChanges = true;
        }

        const homeChanges = {};
        if (this.home.deliveryLine1 != this.homeParams.deliveryLine1) {
          homeChanges.deliveryLine1 = this.home.deliveryLine1;
        }
        if (this.home.deliveryLine2 != this.homeParams.deliveryLine2) {
          homeChanges.deliveryLine2 = this.home.deliveryLine2;
        }
        if (Object.keys(homeChanges).length > 0) {
          batch.update(homeRef, homeChanges);
          hasChanges = true;
        }

        const ordersChanges = {};
        if (this.orders.orderMinimum != this.ordersParams.orderMinimum) {
          ordersChanges.orderMinimum = this.orders.orderMinimum;
        }
        if (this.orders.orderNumber != this.ordersParams.orderNumber) {
          ordersChanges.orderNumber = this.orders.orderNumber;
        }
        if (this.orders.showPreferedDeliveryTime != this.ordersParams.showPreferedDeliveryTime) {
          ordersChanges.showPreferedDeliveryTime = this.orders.showPreferedDeliveryTime;
        }
        if (this.orders.validateLocation != this.ordersParams.validateLocation) {
          ordersChanges.validateLocation = this.orders.validateLocation;
        }
        if (Object.keys(ordersChanges).length > 0) {
          batch.update(ordersRef, ordersChanges);
          hasChanges = true;
        }

        this.seasonal.products = this.seasonal.productsList.join(',');
        if (this.seasonal.title != this.seasonalParams.title || this.seasonal.products != this.seasonalParams.products) {
          batch.update(seasonalRef, {title: this.seasonal.title, products: this.seasonal.products});
          hasChanges = true;
        }

        const self = this;

        if (!hasChanges) {
          self.reset_data();
          self.$vs.loading.close();
          return;
        }

        batch.commit()
          .then(() => {
            self.$vs.notify({
              title: 'Información actualizada',
              text: 'Parámetros guardados correctamente',
              color: 'primary'
            });
            self.reset_data();
            self.$vs.loading.close();
          })
          .catch((error) => {
            self.$vs.notify({
              title: 'Error al guardar parámetros',
              text: error.message,
              color: 'danger'
            });
            self.$vs.loading.close();
          });
      }
    },
    mounted() {
      const self = this;
      setTimeout(function () {
        self.reset_data();
      }, 500);
    }
  }
</script>

<style lang="scss">
  @import '../../../node_modules/@syncfusion/ej2-base/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-buttons/styles/material.css';
  /*@import '../../../node_modules/@syncfusion/ej2-calendars/styles/material.css';*/
  @import '../../../node_modules/@syncfusion/ej2-vue-dropdowns/styles/material.css';
  @import '../../../node_modules/@syncfusion/ej2-inputs/styles/material.css';
  /*@import '../../../node_modules/@syncfusion/ej2-navigations/styles/material.css';*/
  /*@import '../../../node_modules/@syncfusion/ej2-popups/styles/material.css';*/
  /*@import '../../../node_modules/@syncfusion/ej2-splitbuttons/styles/material.css';*/
  /*@import "../../../node_modules/@syncfusion/ej2-vue-grids/styles/material.css";*/
</style>
